<template>
  <card
    @onRemoveItem="handleRemove"
    :item="item"
    :user="user"
    model="herd-item"
    :image="imagePath"
    :url="url"
    buttonText="See More"
  >
    <ul class="card-details herd-item-details">
      <li v-if="item.name">
        <span class="elr-bold">Name:</span> <router-link :to="`/pony/${item.collectible_id}`">{{capitalize(item.name)}}</router-link>
      </li>
      <li v-if="item.generation && item.generation.name">
        <span class="elr-bold">Generation:</span> {{capitalize(item.generation.name)}}
      </li>
      <li v-if="item.grouping && item.grouping.name">
        <span class="elr-bold">Grouping:</span> {{capitalize(item.grouping.name)}}
      </li>
      <li v-if="item.status">
        <span class="elr-bold">Status:</span> {{capitalize(item.status)}}
      </li>
      <li v-if="item.condition">
        <span class="elr-bold">Condition:</span> {{capitalize(item.condition)}}
      </li>
      <li v-if="item.price">
        <span class="elr-bold">Price:</span> {{currency(item.price)}}
      </li>
    </ul>
  </card>
</template>

<script>
import { capitalize, currency, getImagePath } from '../../utils/helpers';
import Card from '../Card/Card';

export default {
  name: 'HerdItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    }
  },
  components: {
    Card
  },
  computed: {
    imagePath() {
      return getImagePath(this.item?.image);
    },
    url() {
      // return `/herd-item/${this.item.id}`;
      return '#';
    }
  },
  methods: {
    capitalize,
    currency,
    handleRemove() {
      this.$emit('onRemove', { slug: this.item.id });
    }
  }
};
</script>

<style scoped lang="scss">
.herd-item-details {
  border-bottom: 0;
}

.card-details {
  padding-top: 10px;
  padding-bottom: 10px;
  list-style: none;
  margin: 0;
  padding-left: 5px;

  li {
    padding: 5px 0;
  }

  li,
  p {
    font-size: 14px;
  }
}
</style>
